import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, empty } from 'rxjs';
import { IMacro, IMacrosByIdBody, IMasterData, Macro, BaseResponse } from '../models';
import { ApiService } from './api.service';
import { ConfigService } from './config.service';
import { map, tap, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MacroService {
   //#region constructor & Members
  constructor(private httpClient: HttpClient) { }
    //#endregion

  //#region   Api endPoints
  public getAll(): Observable<Array<IMacro>> {
    const endPoint = `${ConfigService.APIs.endPoints.MACRO.GET_ALL}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  public add(body: IMacro): Observable<IMacro> {
    const endPoint = `${ConfigService.APIs.endPoints.MACRO.ADD}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => { let result: any; result = response.data; return result; } )
    );
  }
  public update(body: IMacro): Observable<IMacro> {
    const endPoint = `${ConfigService.APIs.endPoints.MACRO.UPDATE}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => { let result: any; result = response.data; return result; } )
    );
  }
  public macrosById(body: IMacrosByIdBody): Observable<Array<IMacro>> {
    const endPoint = `${ConfigService.APIs.endPoints.MACRO.MACROS_BY_ID}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }

  public delete(body: IMacro): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.MACRO.DELETE}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => { let result: any; result = response.data; return result; })
    );
  }
  //#endregion
  editmacro: IMacro = new Macro();

  targets: Array<IMasterData> = [
    { name: "None", value: "None", checked: false },
    { name: "Product", value: "Product", checked: false },
    { name: "KwikKey", value: "KwikKey", checked: false },
  ];

  types: Array<IMasterData> = [
    { name: "Query", value: "Query", checked: false },
    { name: "Update", value: "Update", checked: false },
    { name: "Validate", value: "Validate", checked: false },
    { name: "ValidateOnChange", value: "ValidateOnChange", checked: false },
    { name: "RepositionRules", value: "RepositionRules", checked: false }
  ];


}
